import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../../utils/styles';

export type ButtonType = 'button' | 'submit' | 'reset';

export interface IButton extends IComponent {
  isDisabled?: boolean;
  type?: ButtonType;
}

const classNames = (): IClassNames =>
  makeClassNames({
    button: ['button'],
  });

const Button: React.FC<IButton> = ({ children, isDisabled = false, type = 'button', dataAttributes = {} }) => {
  const cn = classNames();

  return (
    // eslint-disable-next-line react/button-has-type
    <button disabled={isDisabled} type={type} className={cn.button} {...dataAttributes}>
      {children}
    </button>
  );
};

Button.propTypes = {
  isDisabled: PropTypes.bool,
};

export default Button;
